import { COPY_CUSTOMER_WEBSITE } from '../types'

export function doCopyCustomerWebsite(url) {
  return {
    type: COPY_CUSTOMER_WEBSITE,
    payload: { url },
  }
}
